// "Unit types" on the Overview tab: distinct layouts (Studio, 1 BR, …), never the number of unit rows.
// 100% Commission projects list one apartment per unit, so the row count read as the units available.
type LabelLike = { en?: string | null } | string | null | undefined;
type UnitLike = { rooms_count?: LabelLike; title?: LabelLike; type?: LabelLike };

const text = (value: LabelLike): string =>
  (typeof value === 'string' ? value : (value?.en ?? '')).trim().toLowerCase().replace(/\s+/g, ' ');

export const distinctUnitTypeCount = (apartments: readonly UnitLike[] | null | undefined): number => {
  const labels = new Set<string>();
  for (const apartment of apartments ?? []) {
    const label = text(apartment.rooms_count) || text(apartment.title) || text(apartment.type);
    if (label) labels.add(label);
  }
  return labels.size;
};
